const enGB = {
  navigation: {
    mydevice: "マイ・デバイス",
    mymobile: "My mobile"
  },
  photoorganiser: {
    navigation: {
      photos: "写真",
      favorites: "お気に入り",
      collections: "コレクション",
      events: "イベント",
      latestuploads: "最新アップロード"
    },
    empty(source) {
      return "に写真がありません " + source
    }
  },
  mymobile: {
    title: "Get your phone photos in an instant!",
    qrcode: {
      title: "Scan the QR code",
      subtitle: "(No need to install App)"
    },
    instruction: {
      title: "Let's get started!",
      step_1: "Open your camera app",
      step_2: "Scan the QR code",
      step_3: "Follow the instruction on your mobile"
    }
  },
  layout: {
    flex: "フレキシブル",
    square: "スクエア"
  },
  calender: {
    allmonths: "全ての月",
    allyears: "全ての年",
    months: {
      january: "1月",
      february: "2月",
      march: "3月",
      april: "4月",
      may: "5月",
      june: "6月",
      july: "7月",
      august: "8月",
      september: "9月",
      october: "10月",
      november: "11月",
      december: "12月"
    }
  },
  generic: {
    sortBy: "次の順序で並び替え",
    selected: "選択済み",
    done: "写真を追加する",
    back: "戻る",
    images: "写真",
    selection: "セレクション",
    date: "日付",
    name: "名前",
    az: "ファイル名 A-Z",
    za: "ファイル名 Z-A",
    newestfirst: "撮影日 新しい-古い",
    oldestfirst: "撮影日 古い-新しい",
    photos: "写真",
    all: "全て",
    yes: "はい",
    no: "いいえ",
    nodate: "日付なし"
  },
  rangeText: {
    minMax(min, max) {
      return min + " と " + max + " の写真から選択する必要があります"
    },
    min(min) {
      return "フォトブックの作成には" + min + "枚以上の写真が必要です。"
    },
    max(max) {
      return "最大 " + max + " 写真を選択できます"
    }
  },
  addMorePhotos: "別の写真を追加",
  upload: {
    browseButton: "写真を追加",
    uploadlimit(maxSize) {
      return "写真はファイルサイズの" + maxSize + "以下にしてください"
    },
    dragImage: "または写真 をここにドラッグ＆ドロップしてください。",
    errors: {
      GENERIC_ERROR: "何か問題が生じました。 後ほどお試しになるかカスタマーケアにお問合せ下さい。",
      EMPTY_FILE: "画像の参照先がありません。画像を追加してください",
      MAX_FILE_SIZE: "ファイルサイズは{0}MB以下にしてください",
      UNSUPPORTED_FILE_TYPE: "サポートされていないファイル形式です",
      MAX_IMAGE_RESOLUTION: "ファイルサイズは{0}ピクセル以下にしてください",
      INVALID_IMAGE: "ファイルが壊れています"
    },
    errorSummary(number) {
      return number + " ファイルをアップロードできませんでした"
    },
    errorDialog: {
      headline: "あれ！",
      ingress: "次のファイルをアップロードできませんでした：",
      filenameColumn: "ファイル",
      reasonColumn: "原因"
    },
    uploaded: "アップロード済",
    estimating: "推定時間",
    estimatedleft: "推定残り時間",
    ok: "OK",
    cancel: "キャンセル",
    details: "詳細"
  }
}

export default enGB
